import { MutableRefObject } from 'react';
import L from 'leaflet';

export const addLayersChunked = (
  clusterLayer: any,
  markers: L.Marker[],
  generationRef: MutableRefObject<number>,
): (() => void) => {
  const generation = ++generationRef.current;
  clusterLayer.clearLayers();

  let offset = 0;
  let timerId: ReturnType<typeof setTimeout>;

  const processChunk = () => {
    if (generation !== generationRef.current) return;

    const start = Date.now();
    let end = offset;
    while (end < markers.length && Date.now() - start < 200) {
      end++;
    }

    if (end > offset) {
      clusterLayer.addLayers(markers.slice(offset, end));
      offset = end;
    }

    if (offset < markers.length) {
      timerId = setTimeout(processChunk, 50);
    }
  };

  timerId = setTimeout(processChunk, 0);

  return () => {
    clearTimeout(timerId);
    clusterLayer.clearLayers();
  };
};
